import React from "react";
import styles from "./RightSidebarSaveFooter.module.scss";

import { Button } from "@blueprintjs/core";

function RightSidebarSaveFooter({
  disableSave,
  saveLabel,
  pageIsLoading,
  onCancel,
  onSave,
  leftButton
}) {
  return (
    <div className={styles.rightSidebarFooter}>
      {leftButton && <div className={styles.leftButton}>{leftButton}</div>}
      <Button disabled={pageIsLoading} onClick={onCancel}>
        Cancel
      </Button>
      <Button
        loading={pageIsLoading}
        disabled={pageIsLoading || disableSave}
        className="filled"
        onClick={onSave}
      >
        {saveLabel || "Save"}
      </Button>
    </div>
  );
}

export default RightSidebarSaveFooter;
